import * as React from "react";
const PrintReport = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    fill="none"
    {...props}
  >
    <mask
      id="abc"
      width={21}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M.85.266h19.301v19.301H.85z" />
    </mask>
    <g mask="url(#abc)">
      <path
        fill="#1C1B1F"
        d="M13.717 6.699V4.286H7.283V6.7H5.675V2.678h9.65v4.02h-1.608Zm1.608 3.619a.778.778 0 0 0 .573-.232.778.778 0 0 0 .231-.573.778.778 0 0 0-.23-.573.778.778 0 0 0-.574-.23.778.778 0 0 0-.573.23.778.778 0 0 0-.231.573c0 .228.077.42.231.573a.778.778 0 0 0 .573.232Zm-1.608 5.227v-3.217H7.283v3.217h6.434Zm1.608 1.608h-9.65v-3.216H2.458V9.11c0-.683.235-1.256.704-1.719A2.344 2.344 0 0 1 4.87 6.7h11.258c.684 0 1.257.23 1.72.693.462.463.693 1.036.693 1.72v4.825h-3.217v3.216Zm1.609-4.825V9.111a.778.778 0 0 0-.232-.573.778.778 0 0 0-.573-.23H4.871a.778.778 0 0 0-.573.23.778.778 0 0 0-.232.573v3.217h1.609V10.72h9.65v1.608h1.609Z"
      />
    </g>
  </svg>
);
export default PrintReport;
